// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ktijW","title":"styles_title__XDj3r","description":"styles_description__s8RWs"};